import { render, staticRenderFns } from "./AppLayout.vue?vue&type=template&id=196f6438&scoped=true"
import script from "./AppLayout.vue?vue&type=script&lang=ts"
export * from "./AppLayout.vue?vue&type=script&lang=ts"
import style0 from "./AppLayout.vue?vue&type=style&index=0&id=196f6438&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196f6438",
  null
  
)

export default component.exports